import template from './mobileSearch.html';
import controller from './mobileSearch.controller';
import './mobileSearch.scss';

let mobileSearchComponent = {
  restrict: 'E',
  bindings: {
    search: '&'
  },
  template,
  controller
};

export default mobileSearchComponent;
